import { render, staticRenderFns } from "./Replace.vue?vue&type=template&id=9131f83a&scoped=true"
import script from "./Replace.vue?vue&type=script&lang=js"
export * from "./Replace.vue?vue&type=script&lang=js"
import style0 from "./Replace.vue?vue&type=style&index=0&id=9131f83a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9131f83a",
  null
  
)

export default component.exports